
import { useState } from "react";

function InputLegend(props)
{

    const [items, setItems] = useState(props.items);



    if(props.valChange != undefined)
    {

        const filtruj = (e) => {

            var inx = e.target.getAttribute('atr-inx');
            
            if(items[inx] != undefined)
            {                
                if(items[inx]["filter"] != undefined)
                {                    
                    props.valChange(items[inx]["filter"]['filed'] , items[inx]['filter']["set"] , true,  items[inx]['filter']["typ"] );    
                }
            }

        }
         

        return (
            <div className="legend_box">
                    Legenda:
                    {
                        items.map( (item, ix) => {
                            return <div className={"legend_item "  +  ("legend_item_"+ix) + " " +  item.cls }  atr-inx={ix}  onClick={filtruj}  >&nbsp; <div className="legend_title shadowx"   >{item.title} / filtruj </div> </div>                    
                        } )
                    }
                            
            </div>
        ) 
    }


    return (
        <div className="legend_box">
                Legenda:
                {
                    items.map( (item, ix) => {
                        return <div className={"legend_item " +  ("legend_item_"+ix) + " " +  item.cls }>&nbsp; <div className="legend_title shadowx">{item.title}</div> </div>                    
                    } )
                }
                        
        </div>
    )
}


export default InputLegend;

